module.exports = __webpack_public_path__ + "static/img/pic-right.4cb7d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic-right.png
// module id = L1g7
// module chunks = 1